<template>
	<auth-container :page="page">
		<h2 class="mb-4">SWCD Information</h2>

		<swcd-form :item="item"></swcd-form>
	</auth-container>
</template>

<script>
	import SwcdForm from './SwcdForm.vue';
	export default {
		name: 'SwcdCreate',
		components: {
			SwcdForm
		},
		data() {
			return {
				page: {
					errors: [],
					loading: false,
					showLogin: false
				},
				item: {
					id: 0,
					name: null
				}
			}
		}
	}
</script>